import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserRoleNames } from 'src/app/core/models/users';
import { RouteGuard } from 'src/app/core/route-guards/route-guard.guard';
import { ActionLogsComponent } from '../shared/components/actionlogs-component/action-logs.component';
import { LicenseParentListComponent } from './components/license-parent-list/license-parent-list.component';
import { LicenseServerListComponent } from './components/license-server-list/license-server-list.component';

import { LicenseServerMainPanelComponent } from './components/license-server-main-panel/license-server-main-panel.component';
import { LicenseSummaryViewComponent } from './components/license-summary-view/license-summary-view.component';

const routes: Routes = [
  {
    path: 'License Servers List',
    component: LicenseParentListComponent,
    canActivate: [RouteGuard],
    data: { role: [UserRoleNames.GlobalAdmin, UserRoleNames.PowerUser, UserRoleNames.DeploymentAdmin] },
  },
  {
    canActivateChild: [RouteGuard],
    path: 'License Servers List/:licenseName', 
    component: LicenseServerMainPanelComponent, 
    children: [
      { path: 'licenses', component: LicenseServerListComponent },
      { path: 'Summary View', component: LicenseSummaryViewComponent },
      { path: 'logs', component: ActionLogsComponent },
      // { path: '', pathMatch: 'full', redirectTo: 'licenses' }
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LicenseServerRoutingModule { }
